import Box from '@mui/material/Box'
import { useRoutes, type AppDispatch } from '../../../store'
import { AdBreak } from 'common/api/v1/types'
import { ActionMenu as BaseActionMenu } from '../../common/Table/ActionMenu'
import DeleteIcon from '@mui/icons-material/Delete'
import { useConfirmationDialog } from '../../common/ConfirmDialog'
import { deleteAdBreak } from '../../../redux/actions/adBreakActions'
import VisibilityIcon from '@mui/icons-material/Visibility'

interface ActionMenuProps {
  adBreak: AdBreak
  dispatch: AppDispatch
}

export const ActionMenu = ({ adBreak, dispatch }: ActionMenuProps) => {
  const routes = useRoutes()
  const { showConfirmation } = useConfirmationDialog()

  return (
    <Box sx={{ display: 'flex' }}>
      <BaseActionMenu
        data-test-id="input-action-menu"
        options={[
          {
            icon: <VisibilityIcon />,
            label: 'View',
            href: routes.adBreaksView({ id: adBreak.id }),
            openInNewTab: false,
          },
          {
            icon: <DeleteIcon />,
            label: 'Remove',
            isDestructive: true,
            onClick: () => {
              showConfirmation(
                () => dispatch(deleteAdBreak(adBreak.id)),
                'Are you sure you want to remove this ad creative?',
              )
            },
          },
        ]}
      />
    </Box>
  )
}
